module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h1>Uploading <span class="amount"></span> files&#8230;</h1>\n<div class="uploading-bars"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/sceneLoadingScreen/SceneEditorLoadingScreen.tpl
// module id = 2979
// module chunks = 0